export default class EventEmitter {
	constructor(options = {}) {
		this.subscriptions = options.subscriptions;
		this.activeSubscriptions = [];
	}

	init() {
		if (this.$eventTarget == null) {
			this.$eventTarget = document.body;
		}

		if (
			this.subscriptions == null ||
			!Array.isArray(this.subscriptions) ||
			!this.subscriptions.length
		) {
			return;
		}

		for (const subscription of this.subscriptions) {
			if (
				!subscription.hasOwnProperty('event') ||
				!subscription.hasOwnProperty('callback') ||
				typeof subscription.callback !== 'function'
			) {
				continue;
			}

			this.activeSubscriptions.push(this.subscribe(subscription.event, subscription.callback));
		}
	}

	subscribe(event, callback) {
		if (!event || !callback) return;

		if (!this.$eventTarget) {
			throw new Error('EventEmitter: Event target element is not defined!');
		}

		this.$eventTarget.addEventListener(event, callback);

		return {
			$eventTarget: this.$eventTarget,
			callback,
			unsubscribe: () => {
				this.unsubscribe(event, callback);
			}
		}
	}

	unsubscribe(event, callback) {
		if (!event || !callback) return;

		if (!this.$eventTarget) {
			throw new Error('Root element is not defined!');
		}

		this.$eventTarget.removeEventListener(event, callback);
	}

	dispatchEvent(event, payload = null) {
		if (!event) return;

		if (!this.$eventTarget) {
			throw new Error('Root element is not defined!');
		}

		this.$eventTarget.dispatchEvent(new CustomEvent(event, {
			'detail': payload
		}));
	}
}